/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalConfirmarUsuarioAliases {
  AVATAR_0 = 'avatar-0',
  AVATAR_1 = 'avatar-1',
  BUTTON_FECHAR = 'button-fechar',
  LOADER_0 = 'loader-0',
  MODAL_CONFIRMAR_USUARIO = 'modal-confirmar-usuario',
  PANEL_0 = 'panel-0',
  PANEL_AVISO = 'panel-aviso',
  PANEL_AVISO_FALHA = 'panel-aviso-falha',
  PANEL_AVISO_SUCESSO = 'panel-aviso-sucesso',
  PANEL_LOADER = 'panel-loader',
}
export { ModalConfirmarUsuarioAliases };
